import useOnMount from '@rio-cloud/rio-uikit/hooks/useOnMount';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import type { Dispatch } from '../../../types';
import { getGeofences } from '../../actions/geofenceActions';
import { fetchPOIs, showDeletePOIDialog } from '../../actions/poiActions';
import { Routing } from '../../app/Routing';
import POIAndGeofenceTable from '../../table/POIAndGeofenceTable.container';

interface PoiAdministrationProps {
    fetchPOIData: () => void;
    showDeletePOIDialog: (poiId: string) => void;
}

const PoiAdministration = (props: PoiAdministrationProps) => {
    const navigate = useNavigate();

    const showEditPOIDialog = (poiId: string) => {
        navigate(Routing.poiEdit.replace(':id', poiId));
    };

    useOnMount(() => {
        props.fetchPOIData();
    }, []);

    return (
        <div className={'height-100pct'} data-component={'POIPage'}>
            <POIAndGeofenceTable
                showDeleteConfirmation={props.showDeletePOIDialog}
                showUpdateDialog={showEditPOIDialog}
                navigate={navigate}
            />
        </div>
    );
};

const mapDispatchToProps = (dispatch: Dispatch): PoiAdministrationProps => ({
    fetchPOIData() {
        dispatch(fetchPOIs());
        dispatch(getGeofences());
    },
    showDeletePOIDialog(poiId) {
        dispatch(showDeletePOIDialog(poiId));
    },
});

export default connect(undefined, mapDispatchToProps)(PoiAdministration);
